import { render } from "./TableListCommissions.vue?vue&type=template&id=c52e6fce"
import script from "./TableListCommissions.vue?vue&type=script&lang=js"
export * from "./TableListCommissions.vue?vue&type=script&lang=js"

import "./TableListCommissions.vue?vue&type=style&index=0&id=c52e6fce&lang=scss"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__